/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Role within the team
 * @export
 */
export const TeamFormationRole = {
    CAPTAIN: 'CAPTAIN',
    MEMBER: 'MEMBER'
} as const;
export type TeamFormationRole = typeof TeamFormationRole[keyof typeof TeamFormationRole];


export function instanceOfTeamFormationRole(value: any): boolean {
    for (const key in TeamFormationRole) {
        if (Object.prototype.hasOwnProperty.call(TeamFormationRole, key)) {
            if (TeamFormationRole[key as keyof typeof TeamFormationRole] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TeamFormationRoleFromJSON(json: any): TeamFormationRole {
    return TeamFormationRoleFromJSONTyped(json, false);
}

export function TeamFormationRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamFormationRole {
    return json as TeamFormationRole;
}

export function TeamFormationRoleToJSON(value?: TeamFormationRole | null): any {
    return value as any;
}

export function TeamFormationRoleToJSONTyped(value: any, ignoreDiscriminator: boolean): TeamFormationRole {
    return value as TeamFormationRole;
}

